<template>
  <!-- eslint-disable vue/max-len -->
  <svg
    :width="width"
    :height="height"
    :viewBox="viewBox"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"

    :class="$props.class">
    <g v-if="(icon === 'chevron-left' && dir === 'ltr') || (icon === 'chevron-right' && dir === 'rtl')">
      <path id="shape" d="M9.99979 2L11.5498 3.5L7.04981 8L11.5498 12.5L9.99979 14L3.99979 8L9.99979 2Z" />
    </g>
    <g v-if="(icon === 'chevron-right' && dir === 'ltr') || (icon === 'chevron-left' && dir === 'rtl')">
      <path id="shape" d="M5.55002 14L4 12.5L8.5 8L4 3.5L5.55002 2L11.55 8L5.55002 14Z" />
    </g>
    <g v-if="(icon === 'chevron-line-left' && dir === 'ltr') || (icon === 'chevron-line-right' && dir === 'rtl')">
      <path d="M4 2H2V14H4V2Z" />
      <path d="M12.55 3.5001L11 2.0001L5 8.0001L11 14.0001L12.55 12.5001L8.05002 8.0001L12.55 3.5001Z" />
    </g>
    <g v-if="(icon === 'chevron-line-right' && dir === 'ltr') || (icon === 'chevron-line-left' && dir === 'rtl')">
      <path d="M2 12.5L3.55002 14L9.55002 8L3.55002 2L2 3.5L6.5 8L2 12.5Z" />
      <path d="M13 2H11V14H13V2Z" />
    </g>
    <g v-if="icon === 'note-check'">
      <path
        id="Shape"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 14.0001H2V2.00006H11V9.00006H13V6.10352e-05H0V16.0001H7V14.0001ZM4 4.00006H9V6.00006H4V4.00006ZM4 9.00006H9V7.00006H4V9.00006ZM11 13.2001L14.6 9.60006L16 11.0001L11 16.0001L7.8 12.8001L9.2 11.4001L11 13.2001Z"
        fill="#252525" />
    </g>
    <g v-if="icon === 'cross'">
      <path d="M9.40005 7.99999L14.2 12.8L12.8 14.2L8.00005 9.39999L3.20005 14.2L1.80005 12.8L6.60005 7.99999L1.80005 3.19999L3.20005 1.79999L8.00005 6.59999L12.8 1.79999L14.2 3.19999L9.40005 7.99999Z" />
    </g>
    <g v-if="icon === 'check'">
      <path id="shape" d="M4.575 10.2L0 5.62499L1.05 4.57499L4.575 8.09999L10.95 1.79999L12 2.84999L4.575 10.2Z" />
    </g>
    <g v-if="icon === 'trash'">
      <path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M2 3H1V5H2.15385L3 16H13L13.8462 5H15V3H14H11.9941H4.00591H2ZM11.8402 5H4.15975L4.85206 14H11.1479L11.8402 5Z" />
      <rect id="Rectangle 12" x="5" width="6" height="2" />
    </g>
    <g v-if="icon === 'status-ok'" clip-path="url(#clip0_876_1090)">
      <path id="checkbox-inverted" d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM6.4 12L2.4 8L3.528 6.872L6.4 9.736L12.472 3.664L13.6 4.8L6.4 12Z" fill="#749F4A" />
    </g>
    <g v-if="icon === 'status-warn'">
      <path id="Path" d="M8 0L0 16H16L8 0Z" fill="#FDC543" />
      <path id="Path_2" d="M9.20005 6.3999L8.70005 11.2999H7.30005L6.80005 6.3999H9.20005Z" fill="black" />
      <path id="Path_3" d="M7.9999 14.5C7.3999 14.5 6.8999 14 6.8999 13.4C6.8999 12.8 7.3999 12.3 7.9999 12.3C8.5999 12.3 9.0999 12.8 9.0999 13.4C9.0999 14.1 8.5999 14.5 7.9999 14.5Z" fill="black" />
    </g>
    <g v-if="icon === 'status-error'">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM12 10.872L10.872 12L8 9.128L5.128 12L4 10.872L6.872 8L4 5.128L5.128 4L8 6.872L10.872 4L12 5.128L9.128 8L12 10.872Z" fill="#D43B3B" />
    </g>

  </svg>
  <!-- eslint-enable vue/max-len -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { i18n, localeDir } from '@/lang';
// if we render SVG inline, we can manipulate color with CSS
export default defineComponent({
  name: 'StihlIcon',
  props: {
    icon: { type: String, required: true },
    width: { type: Number, default: 16 },
    height: { type: Number, default: 16 },
    viewBox: { type: String, default: '0 0 16 16' },
    class: { type: String, default: null },
  },
  computed: {
    dir() {
      return localeDir(i18n.global.locale);
    },
  },
});
</script>
